import Event from '@oppobrowser/lib-browser-event';
import wv from '@cpc/lib-browser-jsapi';
import { $, debounce } from '@js/utils';
// import './index.scss';
// doc:https://swiperjs.com/get-started#install-from-npm
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

const EventHandler = {};

export default class Banner {
  constructor(el, name, data = {}) {
    this.el = el;
    this._eventHandler = {};
    this.activeIndex = 0;
    this.bannerList = window.pageData?.DOCINFO?.bannerList || []; // 图片列表
    this.bannerBgDom = $('.banner__bg');
    this.bannerContainerDom = $('.banner__container');
    this.bannerInnerPaginationDom = $('.banner__inner-pagination');
    this.bannerCurrentPaginationDom = $(
      '.banner__inner-pagination__current-pos',
    );
    this.bannerPaginationDom = $('.banner__pagination');
    this.bannerProgress = $('.banner__dot');

    this.hideInnerPagination = debounce(
      this.hideInnerPagination.bind(this),
      3000,
    ); // 三秒后才隐藏

    // 处理图片预览
    this.initImagePreview();
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  initImagePreview() {
    this.imagePreviewList = this.bannerList.map((item) => {
      return {
        image: item.picUrl || item.url || '',
        isLongImage: false,
        animated: false,
        low: item.picUrl || item.url || '',
      };
    }); // 预览图片列表
    wv.initArticlePics(() => this.imagePreviewList);
  }

  bannerClick(index) {
    if (wv.isMethodValid('BrowserIFlow.switchBigPicMode')) {
      wv.invoke('BrowserIFlow.switchBigPicMode', [
        this.imagePreviewList?.[index]?.image || '',
      ]);
    } else {
      console.error('版本过低不支持方法:　BrowserIFlow.switchBigPicMode');
    }
  }

  initSwiper() {
    window.bannerSwiper = this.swiper = new Swiper('.banner__container-box', {
      slidesPerView: 1,
      speed: 600,
      watchOverflow: true, // 因为仅有1个slide，swiper无效
      lazy: {
        loadPrevNext: true,
      },
      // autoHeight: true, //高度随内容变化 文章会闪动
      uniqueNavElements: false,
      allowSlidePrev: true, // 禁止从左往右滑动第一个幻灯片 有时轮播会卡在中间 不禁止
      modules: [Pagination],
      pagination: {
        el: '.banner__pagination',
        type: 'bullets',
        dynamicBullets: true,
        dynamicMainBullets: 4,
      },
      on: {
        click: () => {
          this.bannerClick(this.swiper.activeIndex);
        },
        slideChangeTransitionEnd: () => {
          this.bannerBgDom.style.opacity =
            this.swiper.activeIndex === this.bannerList.length - 1 ? 1 : 0;
          // this.swiper.allowSlidePrev = this.swiper.activeIndex !== 0;
          this.bannerCurrentPaginationDom.innerHTML =
            this.swiper.activeIndex + 1;
          this.bannerInnerPaginationDom?.classList.add('show');
          this.hideInnerPagination();
        },
        slideChangeTransitionStart: () => {
          this.resolvePagination();
          const prevDom = $('.swiper-pagination-bullet.swiper-pagination-bullet-active-prev');
          const nextDom = $('.swiper-pagination-bullet.swiper-pagination-bullet-active-next');

          let css = '';
          // 有prev指示点时 next-next 节点隐藏
          if (prevDom) {
            css += '.banner__pagination .swiper-pagination-bullet-active-next-next{opacity: 0!important;transition-duration: 0ms!important;}';
          }

          // 有next指示点时 prev-prev 节点隐藏
          if (nextDom) {
            css += '.banner__pagination .swiper-pagination-bullet-active-prev-prev{opacity: 0!important;transition-duration: 0ms!important;}';
          }

          window.globalTheme?.appendCssToPage(css, 'swiper-pagination-bullet-active');

          this.activeIndex = this.swiper.activeIndex;
        },
        resize: () => {
          this.swiper.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
        },
      },
    });
  }

  hideInnerPagination() {
    this.bannerInnerPaginationDom?.classList.remove('show');
  }

  resolvePagination() {
    return
    const isPlus = this.swiper.activeIndex > this.activeIndex;
    const baseLeft =
      this.bannerPaginationDom.getBoundingClientRect().left -
      this.el.getBoundingClientRect().left +
      3 +
      (isPlus ? this.activeIndex : this.activeIndex - 1) * 12;
    const plusAnimation = [
      {
        left: `${baseLeft}px`,
        right: 'unset',
        width: '6px',
      },
      {
        left: `${baseLeft}px`,
        right: 'unset',
        width: '18px',
      },
      {
        left: 'unset',
        right: `calc(100% - ${baseLeft}px - 18px)`,
        width: '18px',
      },
      {
        left: 'unset',
        right: `calc(100% - ${baseLeft}px - 18px)`,
        width: '6px',
      },
    ];

    this.bannerProgress.style.left = `${baseLeft}px`;
    if (!this.bannerProgress.animate) {
      return;
    }
    const animation = isPlus ? plusAnimation : plusAnimation.reverse();

    const animateInstance = this.bannerProgress.animate(animation, {
      duration: 600,
    });

    animateInstance.onfinish = () => {
      this.bannerProgress.style.left = animation[animation.length - 1].left;
      this.bannerProgress.style.right = animation[animation.length - 1].right;
    };
  }

  resolveBannerProgress() {
    // const baseLeft =
    //   this.bannerPaginationDom.getBoundingClientRect().left -
    //   this.el.getBoundingClientRect().left +
    //   3 +
    //   this.activeIndex * 12;
    // this.bannerProgress.style.left = `${baseLeft}px`;
    // this.bannerProgress.style.display = 'inline-block';
  }

  render() {
    this.initSwiper();

    if (this.bannerList.length > 1) {
      this.resolveBannerProgress();
    }

    this.bannerInnerPaginationDom?.classList.add('transition');

    window.addEventListener(
      'resize',
      debounce(() => {
        this.resolveBannerProgress();
      }, 100),
    );
  }
}
